import { z } from 'zod';
import { createKeyRecordSchema } from '../KeyRecordSchemas.ts';
import { validateState } from '../ValidateState.ts';
import { EnumUtils } from '@colonist/utils';
import { PlayerColor } from '../PlayerState.ts';
const mechanicLargestArmyPlayerStateSchema = z.object({
    hasLargestArmy: z.union([
        z.literal(true),
        z.null()
    ]).exactOptional()
}).strict();
const playerColorNumericKeys = EnumUtils.getEnumValues(PlayerColor);
export const mechanicLargestArmyStateSchema = createKeyRecordSchema(playerColorNumericKeys, mechanicLargestArmyPlayerStateSchema);
export function validateMechanicLargestArmyState(data) {
    return validateState(mechanicLargestArmyStateSchema, data);
}
// All player state fields are already optional, so the partial just requires at least one player entry
export const mechanicLargestArmyStatePartialSchema = createKeyRecordSchema(playerColorNumericKeys, mechanicLargestArmyPlayerStateSchema, {
    requireAtLeastOneEntry: true
});
